import { MutableRefObject, useCallback, useEffect, useRef } from 'react';

const STABLE_CONNECTION_MS = 10000;

const useStableRetryReset = (triesRef: MutableRefObject<number>): (() => void) => {
  const stableConnectionTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const scheduleRetryReset = useCallback((): void => {
    if (stableConnectionTimerRef.current) {
      clearTimeout(stableConnectionTimerRef.current);
    }

    stableConnectionTimerRef.current = setTimeout(() => {
      triesRef.current = 0;
      stableConnectionTimerRef.current = null;
    }, STABLE_CONNECTION_MS);
  }, [triesRef]);

  useEffect(
    () => () => {
      if (stableConnectionTimerRef.current) {
        clearTimeout(stableConnectionTimerRef.current);
      }
    },
    [],
  );

  return scheduleRetryReset;
};

export default useStableRetryReset;
